export default {
  noData: 'Es wurden keine Ereignisse für die aktuellen Filterkriterien gefunden.',
};
